import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Ticket } from 'src/app/interfaces/ticket';
import { IonicModule } from '@ionic/angular';
import { dateFormatValidator } from 'src/app/validators/date-format.validator';

@Component({
  selector: 'app-ticket-input',
  standalone: true,
  imports: [
    IonicModule,
    ReactiveFormsModule
  ],
  templateUrl: './ticket-input.component.html',
  styleUrl: './ticket-input.component.scss'
})
export class TicketInputComponent {

  @Input() public ticketIndex: number = 0
  @Input() public ticketData: Ticket = {}
  @Input() public showForm: boolean = false
  @Input() public disabled: boolean = false
  @Input() public canDelete: boolean = true
  @Input() public canEdit: boolean = true

  @Output() ticketUpdate = new EventEmitter<Ticket>();
  @Output() ticketDelete = new EventEmitter<number>();

  public ticketHolder: Ticket = {}
  public birthdayMaxDate: Date = new Date()
  public hasError: boolean = false

  public seatOptions = []

  public ticketForm = new FormGroup({
    name: new FormControl('', Validators.required),
    birthday: new FormControl('', dateFormatValidator()),
    phone: new FormControl('',),
    destination: new FormControl(''),
    ticket_type: new FormControl('', Validators.required),
    ticket_name: new FormControl(''),
  })

  ngOnInit() {
    this.ticketForm.statusChanges.subscribe(status => {
      if(status === 'VALID') {
        this.hasError = false
      } else {
        this.hasError = true
      }
    })
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['ticketData']) {
      this.ticketForm.patchValue(changes['ticketData'].currentValue)
      this.ticketHolder = this.ticketForm.value as Ticket

      if(this.ticketData.hasError) {
        this.hasError = true
      }
      if (this.ticketData?.formOptions?.seatOptions) {
        this.seatOptions = this.ticketData.formOptions.seatOptions;
      }

      // Show this needs to be filled out
      if (this.ticketForm.invalid || this.hasError) {
        this.showForm = true;
      }
    }
  }


  /**
   * Emmit save ticket event with the form data
   */
  public saveTicket() {
    this.showForm = false
    this.ticketHolder = this.ticketForm.value as Ticket
    this.ticketUpdate.emit(this.ticketHolder)
  }


  /**
   * Emmit delete event with the current ticket index
   */
  public deleteTicket() {
      this.ticketDelete.emit(this.ticketIndex)
  }

}
